"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useItemSelector;
exports.moneyStr = moneyStr;
var _react = _interopRequireWildcard(require("react"));
var _itemSelectorComponent = _interopRequireDefault(require("./item-selector-component"));
var _contexts = require("../app/contexts");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
const STRIKEOUT_CLASS = "donation-encourager__strike-out";
function useItemSelector(_ref) {
  let {
    items,
    preselectedItemsFilter
  } = _ref;
  const preselectedItems = items.filter(preselectedItemsFilter);
  const [selectedItems, setSelectedItems] = (0, _react.useState)(preselectedItems);
  const undiscountedVal = sumUp(selectedItems);
  const discountedVal = useDiscount(undiscountedVal, selectedItems);
  const amount = useAmountObject(undiscountedVal, discountedVal);
  const itemSelector = /*#__PURE__*/_react.default.createElement(_itemSelectorComponent.default, {
    items: items,
    selectedItems: selectedItems,
    setSelectedItems: setSelectedItems
  });
  return [itemSelector, amount];
}
function sumUp(items) {
  return items.reduce((acc, curr) => acc + curr.value, 0);
}
function useDiscount(undiscountedVal, selectedItems) {
  const {
    discount
  } = (0, _react.useContext)(_contexts.Settings);
  return typeof discount === "function" ? discount(undiscountedVal, selectedItems) : undiscountedVal;
}
function useAmountObject(undiscountedVal, discountedVal) {
  const {
    locale,
    strings
  } = (0, _react.useContext)(_contexts.Settings);
  const {
    currency
  } = strings;
  const undiscountedRounded = Math.round(undiscountedVal);
  const discountedRounded = Math.round(discountedVal);
  return (0, _react.useMemo)(() => ({
    val: discountedRounded,
    str: undiscountedRounded !== discountedRounded ? `<span class="${STRIKEOUT_CLASS}">
                <span class="${STRIKEOUT_CLASS}-stroke"></span>
                <span class="${STRIKEOUT_CLASS}-text">
                  ${moneyStr(undiscountedRounded, locale, currency)}
                </span>
              </span> ${moneyStr(discountedRounded, locale, currency)}` : `${moneyStr(undiscountedRounded, locale, currency)}`
  }), [undiscountedRounded, discountedRounded, locale, currency]);
}
function moneyStr(amount, locale, currency) {
  const numberStr = amount.toLocaleString(locale, {
    minimumFractionDigits: amount % 1 ? 2 : 0
  });
  return typeof currency === "function" ? currency(numberStr) : `${numberStr} ${currency}`;
}